import React, { useState } from 'react';
import { Empty, Tooltip } from 'antd';
import PaginationTable from '../../../shared/PaginationTable';
import moment from 'moment';

const LocationListView = (props) => {
  const {
    locationList,
    onChangeStateValue,
    selectedOrgId,
    history,
    isSelfService,
    selectedLocations,
    classificationFilter,
  } = props;

  const columns = [
    {
      title: 'Location Name',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (name, record) => {
        return record.geoframe === null ? (
          <>
            {' '}
            <Tooltip title="No Geo Target">{name}</Tooltip>
          </>
        ) : (
          <>
            <Tooltip title={name}>{name}</Tooltip>
          </>
        );
      },
    },
    {
      title: 'Street Address',
      dataIndex: 'formattedAddress',
      key: 'formattedAddress',
      render: (formattedAddress, record) => {
        // Check if the address is available and not null
        if (formattedAddress) {
          // Remove leading commas and spaces from the address
          const cleanedAddress = formattedAddress.trim().replace(/^, */, '');

          return record.geoframe === null ? (
            <>
              {' '}
              <Tooltip title="No Geo Target">{cleanedAddress}</Tooltip>
            </>
          ) : (
            <>{cleanedAddress}</>
          );
        } else {
          return null; // Handle the case where the address is null or undefined
        }
      },
    },
    {
      title: 'Classification',
      dataIndex: 'licenses',
      key: 'classification',
      render: (licenses) => {
        if (!licenses || licenses.length === 0) {
          return '-';
        }
        const designations = licenses[0]?.designations || [];
        if (designations.length === 0) {
          return '-';
        }
        if (designations.includes('MEDICAL') && designations.includes('RECREATIONAL')) {
          return 'Both';
        }
        if (designations.includes('MEDICAL')) {
          return 'Medical';
        }
        if (designations.includes('RECREATIONAL')) {
          return 'Recreational';
        }
        return '-';
      },
    },
    {
      title: 'Created On',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (text) => {
        return moment(text).utcOffset(0).format('MM/DD/YY - HH:mm [GMT]');
      },
      sorter: (a, b) => moment(a.createdAt).unix() - moment(b.createdAt).unix(),
    },
  ];

  // remove location type column if it has no self-service permissions
  if (isSelfService) {
    columns.splice(2, 0, {
      title: 'Location Type',
      dataIndex: 'locationType',
      key: 'locationType',
      render: (_, record) => {
        return record.locationKey ? 'Retail Store' : 'Walk-In';
      },
    });
  }

  const matchesClassificationFilter = (location) => {
    if (!classificationFilter) return true;
    const designations = location.licenses && location.licenses[0]
      ? location.licenses[0].designations || []
      : [];
    const hasMedical = designations.includes('MEDICAL');
    const hasRecreational = designations.includes('RECREATIONAL');
    const isBoth = hasMedical && hasRecreational;

    switch (classificationFilter) {
      case 'MEDICAL':
        // Show locations that are Medical-only OR Both
        return hasMedical;
      case 'RECREATIONAL':
        // Show locations that are Recreational-only OR Both
        return hasRecreational;
      case 'BOTH':
        // Show only locations that are explicitly Both
        return isBoth;
      default:
        return true;
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  const table = (
    <div>
      <PaginationTable
        columns={columns}
        data={
          locationList
            ? locationList
                .filter(
                  (location) =>
                    location.audienceType === 'ATTRIBUTION' && location.org.id === selectedOrgId
                )
                .filter(matchesClassificationFilter)
            : []
        }
        bordered={false}
        rowSelection={{
          type: 'checkbox',
          selectedRowKeys: selectedLocations ? selectedLocations.map((loc) => loc.id) : [],
          getCheckboxProps: (record) => ({
            disabled: record.geoframe === null,
          }),
          onChange: (selectedRowKeys, selectedRows) => {
            onChangeStateValue('selectedLocations', selectedRows);
          },
        }}
        paginationSize={'default'}
        scroll={{ x: 1200 }}
        size={'default'}
        current={currentPage}
        pageSize={10}
        onChange={(paginationObject, filtersObject, sorterObject) => {
          setCurrentPage(paginationObject.current);
        }}
        onRow={(record, rowIndex) => {
          return {
            onClick: (event) => {
              history.push(`/retails_stores/details/${record.id}`);
            },
          };
        }}
      />
    </div>
  );

  return locationList && locationList.length ? table : <Empty />;
};

export default LocationListView;
